import RequestFactory from "../../utility/requestFactory";

// trip-service: Operator Broadcast APIs for the logged-in operator.
const BASE = "trip/v1/auth/operator/broadcast";

function errorMessage(err) {
  const body = err && err.body;
  const e = body && body.error;
  if (e && typeof e.message === "string") return e.message;
  if (typeof body === "string") return body;
  return "Something went wrong. Please try again.";
}

function handlers(resolve, reject) {
  return [
    (res) => {
      if (res && res.status >= 200 && res.status < 300) resolve(res.body);
      else reject(new Error(errorMessage(res)));
    },
    (err) => reject(new Error(errorMessage(err))),
  ];
}

export const fetchAccess = () =>
  new Promise((resolve, reject) => {
    const [ok, fail] = handlers(resolve, reject);
    RequestFactory.withService("trnzApi").get(`${BASE}/access`, ok, fail);
  });

export const fetchBookings = (params) =>
  new Promise((resolve, reject) => {
    const [ok, fail] = handlers(resolve, reject);
    RequestFactory.withService("trnzApi").get(`${BASE}/bookings`, ok, fail, params);
  });

export const acceptBooking = (bookingId, fare) =>
  new Promise((resolve, reject) => {
    const [ok, fail] = handlers(resolve, reject);
    RequestFactory.withService("trnzApi")
      .setHeaders("Content-Type", "application/json")
      .withRequestBodyType("Json")
      .post(`${BASE}/bookings/${encodeURIComponent(bookingId)}/accept`, { fare }, ok, fail);
  });
